(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-video-journal"] && !Shopify.designMode) return;
  try {
    
  function bindVideoCategories(root) {
    root.querySelectorAll('.ph-video-journal').forEach(section => {
      if (section.dataset.categoriesBound) return;
      section.dataset.categoriesBound = 'true';
      section.querySelectorAll('.ph-video-category img').forEach(image => {
        const reveal = () => { if (image.naturalWidth > 0) image.classList.add('is-loaded'); };
        image.addEventListener('load', reveal);
        if (image.complete) reveal();
      });
      section.querySelectorAll('[data-playlist]').forEach(button => {
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-pressed') === 'true') return;
          section.querySelectorAll('[data-playlist]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          const player = section.querySelector('iframe');
          player.src = 'https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(button.dataset.playlist) + '&rel=0';
          player.title = button.dataset.title;
          const heading = section.querySelector('.ph-video-journal__selected');
          heading.textContent = button.dataset.title;
          heading.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    });
  }
  bindVideoCategories(document);
  document.addEventListener('shopify:section:load', event => bindVideoCategories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-wedding-rings"] && !Shopify.designMode) return;
  try {
    
function initPhRingGalleries(root) {
  root.querySelectorAll('[data-ph-gallery]').forEach(function (gallery) {
    if (gallery.dataset.phGalleryReady === 'true') return;
    gallery.dataset.phGalleryReady = 'true';
    var track = gallery.querySelector('[data-ph-track]');
    var slides = Array.from(gallery.querySelectorAll('[data-ph-slide]'));
    var dots = Array.from(gallery.querySelectorAll('[data-ph-dot]'));
    var current = 0;
    if (!track || slides.length < 1) return;

    function setCurrent(index, move) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-pressed', dotIndex === current ? 'true' : 'false');
      });
      if (move) track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { setCurrent(index, true); });
    });
    gallery.querySelector('[data-ph-prev]')?.addEventListener('click', function () {
      setCurrent((current - 1 + slides.length) % slides.length, true);
    });
    gallery.querySelector('[data-ph-next]')?.addEventListener('click', function () {
      setCurrent((current + 1) % slides.length, true);
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var next = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setCurrent(next, false);
        ticking = false;
      });
    }, { passive: true });
    setCurrent(0, false);
  });
}

document.addEventListener('DOMContentLoaded', function () { initPhRingGalleries(document); });
document.addEventListener('shopify:section:load', function (event) { initPhRingGalleries(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pryce-house-gateway"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ph-gate]').forEach((link) => {
    link.addEventListener('click', () => {
      const gate = link.dataset.phGate;
      localStorage.setItem('pryceHouseGate', gate);
      document.cookie = `ph_gate=${gate}; path=/; max-age=31536000; SameSite=Lax`;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
